import car_imageUrl from "@/assets/images/get-trackmate/car.png";
import car_thumbnailUrl from "@/assets/images/get-trackmate/car_thumbnail.png";
import devices_imageUrl from "@/assets/images/get-trackmate/devices.png";
import devices_thumbnailUrl from "@/assets/images/get-trackmate/devices_thumbnail.png";
import accessCode_imageUrl from "@/assets/images/get-trackmate/enter-device-sn.png";
import accessCode_thumbnailUrl from "@/assets/images/get-trackmate/enter-device-sn_thumbnail.png";
import mobile_imageUrl from "@/assets/images/get-trackmate/mobile.png";
import mobile_thumbnailUrl from "@/assets/images/get-trackmate/mobile_thumbnail.png";
import { ROUTES } from "../navigation";

export const trackmateData: ITrackmateCard[] = [
  {
    imageUrl: devices_imageUrl,
    thumbnail: devices_thumbnailUrl,
    title: "Buy a Trackmate device",
    details: [
      "Visit our Amazon page",
      // "Visit our solutions page",
      "Compare devices",
      "Choose the right for you",
    ],
    description: "Choose the tracker that’s best for you or your business.",
    button: {
      title: "Buy device",
      path: "https://www.amazon.com/stores/TrackmateGPS/page/75147E64-27A1-4BBF-B5B0-8430EFEF2D84?ref_=ast_bln&store_ref=bl_ast_dp_brandLogo_sto",
    },
  },

  {
    imageUrl: accessCode_imageUrl,
    thumbnail: accessCode_thumbnailUrl,
    title: "Activate your Trackmate device",
    details: ["Log in to our platform", "Enter device serial number"],
    description:
      "Use the app or web platform to walk you through the activation process.",
    button: {
      title: "Activate device",
      path: ROUTES.subscriptionPlans,
    },
  },

  {
    imageUrl: car_imageUrl,
    thumbnail: car_thumbnailUrl,
    title: "Install your Trackmate device",
    details: [
      "Download the installation manual for your new device",
      "Follow a few steps",
    ],
    description:
      "Follow the steps in the installation guide to connect your tracker to your vehicle or asset.",
    button: {
      title: "Installation guide",
      path: ROUTES.installationGuide,
    },
  },

  {
    imageUrl: mobile_imageUrl,
    thumbnail: mobile_thumbnailUrl,
    title: "Start tracking!",
    details: [
      "Track your vehicle in real time",
      "Control/manage remotely",
      "Use our app for convenience",
    ],
    description:
      "View vehicle or asset location and movement on the map in real time and generate reports on the go.",
    button: {
      title: "Download app",
      path: "https://play.google.com/store/apps/details?id=com.fleetManagementServices.pinspot&hl=en&gl=US",
    },
  },
];
